// extracted by mini-css-extract-plugin
export var alt = "ParagraphAnchorLink-module--alt--44e90";
export var container = "ParagraphAnchorLink-module--container--3651f";
export var desktopOnly = "ParagraphAnchorLink-module--desktopOnly--a8a8e";
export var main = "ParagraphAnchorLink-module--main--e6c22";
export var mobileOnly = "ParagraphAnchorLink-module--mobileOnly--4542a";
export var textLeft = "ParagraphAnchorLink-module--textLeft--64bd2";
export var visuallyHidden = "ParagraphAnchorLink-module--visuallyHidden--c1141";